export enum StatusMensagem {
  'Gravada' = 1,
  'Enviada' = 2,
  'Programada' = 3,
  'Não enviada' = 4,
}
